import { gql } from '@apollo/client/core'

export const deliveryDateQuery = gql`
  query getDeliveryDates($printableSkuId: ID!, $quantity: Int!, $zipCode: String!, $orderDate: String, $trial: Boolean, $paymentMethod: String) {
    deliveryDates(printableSkuId: $printableSkuId, zipCode: $zipCode, orderDate: $orderDate, quantity: $quantity, trial: $trial, paymentMethod: $paymentMethod) {
      date {
        name
        value
      }
      paymentMethod
    }
  }
`

export const similarProductsQuery = gql`
  query getSimilarProducts($id: ID!, $offset: Int!, $limit: Int!) {
  similarProducts(id: $id, offset: $offset, limit: $limit) {
    totalItemsCount
    offset
    limit
    items {
      id
      productImage
      displayName
      shortDisplayName
      categoryId
      minPrice
      maxPrice
      minCampaignPrice
      maxCampaignPrice
      minProductQuantity
      maxProductQuantity
      quantityUnit
      printTag
      estimateItemId
    }
  }
}
`

export interface IAwsPersonalizeInput {
  numResults: number,
  pattern: string,
  pageType: string,
  pageArea: string,
}

export const recommendedProductsQuery = gql`
  query getRecommendedProducts($offset: Int!, $limit: Int!, $awsPersonalize: AwsPersonalizeAttribute!) {
  recommendedProducts(offset: $offset, limit: $limit, awsPersonalize: $awsPersonalize) {
    totalItemsCount
    offset
    limit
    recipe
    items {
      id
      productImage
      displayName
      shortDisplayName
      categoryId
      minPrice
      maxPrice
      minCampaignPrice
      maxCampaignPrice
      minProductQuantity
      maxProductQuantity
      quantityUnit
      printTag
    }
  }
}
`
